import { Injectable } from '@angular/core';
import { Growl } from 'angular/custom/services/growl.service';
import { PkpBackendError } from 'app/custom';

@Injectable()
export class ErrorHandlerService {
    constructor(private growl: Growl) {}

    public handle(
        err: PkpBackendError<RestError>,
        fallbackMessage: string = 'An unknown error occurred.'
    ) {
        this.growl.show(
            err && err.error && err.error.message
                ? err.error.message
                : fallbackMessage,
            'danger',
            { errorCode: err.error ? err.error.errorCode : '' }
        );
    }
}
